/**
 * methodIcons — single source of truth for the 3 enrollment-method glyphs.
 *
 * Consumed by:
 *  - `MethodChips`  (small chips on the employees list)
 *  - `MethodRow`    (large rows on the employee detail page — default icons)
 *
 * Each icon accepts `{ size, color }` and renders an SVG that uses `currentColor`,
 * so the consumer controls the colour via `color`. The geometry es la misma que
 * el mockup canónico (`web/Clock Web.html` `.emp-method-chip svg`, extraído
 * 2026-07-14):
 *
 *  - FaceIcon: bracket frame (corners) + head circle + smile curve
 *  - PinIcon:  padlock (body rect + shackle arch)  ← antes era pinpad con dots
 *  - CardIcon: card rect + chip + NFC arcs         ← antes era rect + línea plana
 *
 * Los glyphs anteriores no matcheaban los del mockup — se reescriben con los
 * paths exactos capturados del DOM del prototype.
 */

interface IconProps {
  size: number;
  color?: string;
}

export function FaceIcon({ size, color = 'currentColor' }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 7V5a2 2 0 0 1 2-2h2" />
      <path d="M17 3h2a2 2 0 0 1 2 2v2" />
      <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
      <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
      <circle cx="12" cy="11" r="3" />
      <path d="M7 17c1-2 3-3 5-3s4 1 5 3" />
    </svg>
  );
}

export function PinIcon({ size, color = 'currentColor' }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="11" width="18" height="10" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  );
}

export function CardIcon({ size, color = 'currentColor' }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="2" y="6" width="20" height="14" rx="2" />
      <path d="M16 12h.01" />
      <path d="M20 9c-1.333 1-2 1.5-2 3s.667 2 2 3" />
    </svg>
  );
}
